import VLActionModal from "views/uikit/VLModal/VLActionModal";
import { useParams } from "react-router";
import styles from "./style.module.scss";
import { useReindex } from "hooks/useReindex";
import { useUserPermission } from "hooks/useUserPermission";

interface ReindexModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ReindexModal({ open, onClose }: ReindexModalProps) {
  const { datasetId, newDatasetId } = useParams();

  const { reindex, isLoading } = useReindex(datasetId || newDatasetId, {
    onSuccess: onClose,
  });

  const canReindex = useUserPermission("can_reindex");

  return (
    <VLActionModal
      headers={{ title: "Re-index Dataset" }}
      isOpen={open && canReindex}
      variant={"general"}
      loading={isLoading}
      onClose={onClose}
      actionLabel={"Re-Index"}
      onClick={reindex}
    >
      <div className={styles.contentWrapper}>
        <span className={styles.title}>
          Your new data isn’t fully indexed, so actions like label propagation
          aren’t available yet.
        </span>
        <span className={styles.subTitle}>
          <b>Tip:</b> If more data is coming, Wait and index it all together.
          You can continue exploring meanwhile.
        </span>
      </div>
    </VLActionModal>
  );
}
